var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.25 6.70837H13.75C14.0054 6.70845 14.1991 6.79231 14.3281 6.92126C14.4572 7.05036 14.541 7.24468 14.541 7.50037C14.5409 7.75589 14.4572 7.94945 14.3281 8.07849C14.1991 8.20753 14.0055 8.29131 13.75 8.29138H1.25C0.994312 8.29138 0.799995 8.20759 0.670898 8.07849C0.541948 7.94945 0.458079 7.75579 0.458008 7.50037C0.458008 7.24468 0.541802 7.05036 0.670898 6.92126C0.783777 6.80839 0.946349 6.73022 1.15625 6.71228L1.25 6.70837Z",
    fill: "#A37C4D",
    stroke: "#FDF7E7",
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 0.458374C7.75542 0.458445 7.94908 0.542315 8.07812 0.671265C8.20722 0.800362 8.29102 0.994678 8.29102 1.25037V13.7504C8.29094 14.0059 8.20717 14.1994 8.07812 14.3285C7.94908 14.4575 7.75553 14.5413 7.5 14.5414C7.24431 14.5414 7.05 14.4576 6.9209 14.3285C6.79195 14.1994 6.70808 14.0058 6.70801 13.7504V1.25037L6.71191 1.15662C6.72986 0.946715 6.80802 0.784143 6.9209 0.671265C7.05 0.542168 7.24431 0.458374 7.5 0.458374Z",
    fill: "#A37C4D",
    stroke: "#FDF7E7",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.ec293435289c5c4df8f643ed8056d537.svg";
export { ForwardRef as ReactComponent };